import { Injectable, inject } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { AuthService } from "@auth0/auth0-angular";
import { LOGIN_PATH } from "@sdk/lib/values/shared-paths";
import { PatientProfile } from "@sdk/lib/types/profile";
import { PatientService } from "@sdk/lib/services/patient.service";

@Injectable({
  providedIn: "root",
})
export class NotDeactivatedUserGuard implements CanActivate {
  private _auth = inject(AuthService);
  private _router = inject(Router);
  private _patientService = inject(PatientService);

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._auth.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          void this._router.navigate(["/", LOGIN_PATH]);
          return [false];
        }
        return this._auth.user$.pipe(
          filter((user) => !!user),
          take(1),
          switchMap((user) =>
            this._patientService.getPatientProfileByUserID(user.sub).pipe(
              map((profile: PatientProfile) => {
                if (profile?.is_deactivated === true) {
                  this._router.navigate(['/deactivated']);
                  return false;
                } else {
                  return true;
                }
              }),
            ),
          ),
        );
      }),
    );
  }
}
